import React from "react";
import { Tag, TagProps } from "antd";
import { radius } from "@libertify/ui";

interface ProjectPillProps extends TagProps {
  title?: string;
  color?: string;
}

export const ProjectPill: React.FC<ProjectPillProps> = ({
  title,
  color,
  ...props
}) => {
  const tealPillStyles: React.CSSProperties = {
    background: "#f0fdfb",
    border: "1px solid #ccfbf1",
    color: "#0d9488",
    borderRadius: radius.pill,
    padding: "4px 10px",
    fontSize: "12px",
    fontWeight: 500,
    margin: 0,
    ...(color ? { backgroundColor: color } : {}),
    ...props.style,
  };
  return (
    <Tag {...props} style={tealPillStyles}>
      {title ?? props.children}
    </Tag>
  );
};
